module.exports = __webpack_public_path__ + "img/盾牌男.aa814065.jpg";